import * as React from 'react'
import { createFileRoute, redirect } from '@tanstack/react-router'

import {
  Alert,
  Button,
  Card,
  ErrorMsg,
  Form,
  FormFields,
  Input,
  Paragraph,
} from '~/components/elements'
import { H2 } from '~/components/elements'
import { LoginMain } from '~/components/elements'
import { EmailSent } from '~/components/login/EmailSent'
import Loading from '~/components/loading'
import { useRootStore } from '~/store/RootStore'
import { validateEmail } from '~/utils/helpers'
import { TokenManager } from '~/utils/TokenManager'
import { Constants } from '~/utils/Constants'

export const Route = createFileRoute('/login')({
  beforeLoad: () => {
    const token = TokenManager.getToken()
    if (token && TokenManager.validateToken(token)) {
      return redirect({ to: '/home' })
    } else {
      // the token saved might be invalid already, we need to clear it
      TokenManager.clearToken()
    }
  },
  component: LoginPage,
})

function LoginPage() {
  const { app } = useRootStore()
  const [success, setSuccess] = React.useState(false)
  const [isLoading, setIsLoading] = React.useState(false)
  const [alert, setAlert] = React.useState({
    title: '',
    message: '',
  })
  const [email, setEmail] = React.useState({
    value: '',
    error: false,
    errMsg: '',
  })

  async function onSubmit() {
    if (!email.value) {
      setEmail({
        ...email,
        error: true,
        errMsg: '* Please enter email',
      })
      return
    }

    if (!validateEmail(email.value)) {
      setEmail({
        ...email,
        error: true,
        errMsg: '* Please enter email in valid format',
      })
      return
    }

    setIsLoading(true)

    await app
      .getAuthenticated(email.value)
      .then(() => {
        setAlert({ title: '', message: '' })
        setSuccess(true)
        setIsLoading(false)
      })
      .catch((err) => {
        setIsLoading(false)
        if (err.status === 401) {
          setAlert({
            title: 'Email Not Found:',
            message: 'Please enter your email and try again',
          })
        } else {
          setAlert({
            title: 'Error:',
            message: err.message || 'Please try again.',
          })
        }
      })
  }

  return (
    <LoginMain>
      <Card className="card">
        <img
          className="logo"
          src={`/images/${Constants.WHOLESALERSETTINGS.logo}`}
          style={
            Constants.WHOLESALERCODE === 'LPE' ? { maxWidth: '90%' } : undefined
          }
        />
        <H2>
          {Constants.WHOLESALERCODE === 'LPE'
            ? 'My Broadband Account'
            : 'My Account'}
        </H2>
        {success ? (
          <EmailSent />
        ) : (
          <>
            <Paragraph style={{ marginBottom: '16px' }}>
              Enter your account email address
            </Paragraph>
            {alert.message ? (
              <Alert
                icon
                type="danger"
                title={alert.title}
                message={alert.message}
              />
            ) : (
              ''
            )}
            {isLoading && <Loading />}
            <Form>
              <FormFields>
                <Input
                  required
                  type="text"
                  placeholder="Email"
                  block="true"
                  value={email.value}
                  $error={email.error || undefined}
                  onChange={(e: any) =>
                    setEmail({
                      value: e.currentTarget.value,
                      error: false,
                      errMsg: '',
                    })
                  }
                />
                {email.error && <ErrorMsg>{email.errMsg}</ErrorMsg>}
              </FormFields>

              <Button
                type="button"
                variant="brand"
                block="true"
                onClick={onSubmit}
              >
                Login
              </Button>
            </Form>
          </>
        )}
      </Card>
    </LoginMain>
  )
}
